var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"top-banner"},[_c('p',{staticClass:"banner-text"},[_vm._v("\n        🎁 "),_c('strong',{staticStyle:{"color":"white"}},[_vm._v("¡Activa HOY tu control de stock y obtén 3 meses GRATIS!")]),_vm._v(" "),_c('span',{staticClass:"banner-link",on:{"click":function($event){return _vm.sendMessage()}}},[_vm._v("👉 Aprovechar oferta limitada")])]),_vm._v(" "),_c('button',{staticClass:"banner-close",on:{"click":_vm.closeBanner}},[_vm._v("✖")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba865d0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TopBanner.vue
// module id = 530
// module chunks = 79